/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appVsts_viewer$ref: FragmentReference;
declare export opaque type appVsts_viewer$fragmentType: appVsts_viewer$ref;
export type appVsts_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +vstsEnabled: ?boolean,
    +vstsAccount: ?$ReadOnlyArray<?string>,
    +vstsEstimateField: ?string,
  |},
  +$refType: appVsts_viewer$ref,
|};
export type appVsts_viewer$data = appVsts_viewer;
export type appVsts_viewer$key = {
  +$data?: appVsts_viewer$data,
  +$fragmentRefs: appVsts_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appVsts_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsEstimateField",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd05a021adab46a0bd18fcf67d2dbdccc';

module.exports = node;
